<div class="pdfviewer-map">
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" [zoom-scale]="'page-fit'" [autoresize]="true" style="display: block;"></pdf-viewer>
</div>
<a routerLink="/gallery/documentation" class="nav-link float">
    <fa-icon icon="undo"></fa-icon>
</a>
